import { SET_CUSTOMER } from "../actions/actionTypes";

const initialState = {
    cardCode: undefined,
    name: undefined,
   
}

export default function customerReducer(state = initialState, action: any) {
    switch (action.type) {
        case SET_CUSTOMER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}